import { render, staticRenderFns } from "./Snappicture.vue?vue&type=template&id=21ad768a&scoped=true&"
import script from "./Snappicture.vue?vue&type=script&lang=js&"
export * from "./Snappicture.vue?vue&type=script&lang=js&"
import style0 from "./Snappicture.vue?vue&type=style&index=0&id=21ad768a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad768a",
  null
  
)

/* custom blocks */
import block0 from "./Snappicture.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports